<div class="login-container">
  <!-- Left Side - Login Form -->
  <div class="login-form-side">
    <div class="login-form-wrapper">
      <!-- Logo -->
      <div class="login-logo">
        <div class="logo-icon">
          <img class="image" src="assets/images/Logo.png" alt="Logo">
        </div>
        <div class="logo-text">
          <div class="logo-company">RealTimeTrac</div>
          <div class="logo-tagline">Delivery Management System</div>
        </div>
      </div>

      <!-- Login Header -->
      <div class="login-header">
        <div
          style="font-size: 14px; font-weight: 600; color: var(--primary-green); text-transform: uppercase; letter-spacing: 1px; margin-bottom: 32px;">
          Your customers' time valued
        </div>
      </div>

      <!-- Login Form -->
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form" id="loginForm" novalidate>
        <!-- Email Field -->
        <!-- <div class="form-group">
                        <label class="form-label" for="email">
                            Email Address
                            <span class="required-indicator">*</span>
                        </label>
                        <input 
                         (keydown)="onKeyDown($event)"
                            type="email" 
                            id="email" 
                            class="form-input" 
                            placeholder="you@example.com"
                            formControlName="email"
                            [class.error]="submitted && loginForm.get('email')?.invalid"
                        >
                        <div class="error-message"  *ngIf="submitted &&  loginForm.get('email')?.errors">
                            <svg fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                            </svg>
                            <span id="emailErrorText">Please enter your email address</span>
                        </div>
                    </div> -->
        <app-form-input [form]="loginForm" controlName="email" label="Email Address" type="email"
          placeholder="you@example.com" [submitted]="submitted" [options]="rememberedEmails">
        </app-form-input>

        <!-- Login Button -->
        <button type="submit" class="login-button" [disabled]="isSubmitting">
          <!-- Get Organization
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg> -->
          <ng-container *ngIf="!isSubmitting; else loading">
            Sign In
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </ng-container>

          <ng-template #loading>
            <i class="fa fa-spinner fa-spin"></i>
            <span>Signing in...</span>
          </ng-template>
        </button>

        <!-- Terms -->
        <p class="terms-text">
          By signing in, you agree to our <a href="http://rtt-privacy-policy.s3-website.ap-south-1.amazonaws.com/"
            target="_blank">Terms of Service</a> and <a
            href="http://rtt-privacy-policy.s3-website.ap-south-1.amazonaws.com/" target="_blank">Privacy Policy</a>.
        </p>
      </form>
    </div>
  </div>

  <!-- Right Side - Illustration -->
  <!-- Right Side - Illustration -->
  <div class="illustration-side">
    <div class="slider-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeaveWrapper()">

      <!-- Tagline -->
      <h2 class="slider-tagline">
        Schedule. <span class="highlight-green">TRAC</span>. Deliver on <span class="highlight-yellow">Time</span>
      </h2>

      <!-- Slider Wrapper -->
      <div class="slider-wrapper" #sliderWrapper (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)"
        (mousedown)="onMouseDown($event)" (mousemove)="onMouseMove($event)" (mouseup)="onMouseUp($event)"
        (mouseleave)="onMouseLeave()">

        <!-- Previous Arrow -->
        <button class="slider-arrow prev" (click)="prevSlide()" aria-label="Previous slide">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <!-- Next Arrow -->
        <button class="slider-arrow next" (click)="nextSlide()" aria-label="Next slide">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>

        <!-- Slides -->
        <div class="slide" *ngFor="let slide of slides; let i = index" [ngClass]="{ 'active': currentSlide === i }">
          <div class="slide-image">
            <img [src]="slide.image" [alt]="slide.title">
          </div>
          <div class="slide-content">
            <h3 class="slide-title">{{ slide.title }}</h3>
            <p class="slide-description">{{ slide.description }}</p>
          </div>
        </div>
      </div>

      <!-- Progress Bar -->
      <div class="slider-progress">
        <div class="slider-progress-bar" [style.width.%]="((currentSlide + 1) / slides.length) * 100"></div>
      </div>

      <!-- Navigation Dots -->
      <div class="slider-nav">
        <div class="slider-dot" *ngFor="let slide of slides; let i = index" [ngClass]="{ 'active': currentSlide === i }"
          (click)="showSlide(i)">
        </div>
      </div>

    </div>
  </div>

</div>

<!-- Selection Modal - Sidebar Style -->
<div class="modal-backdrop" (click)="closeSelectionModal()" *ngIf="showSelectionModal" #selectionBackdrop
  [class.show]="showSelectionModal">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <h3>Select Option</h3>
      <button class="close-btn" (click)="closeSelectionModal()">✕</button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <!-- <p>Please select a required option to continue</p> -->
      <form style="margin-top: 16px;">
        <div class="form-group">
          <label>
            Select Company
            <span class="required-indicator">*</span>
          </label>
          <select [(ngModel)]="selectedCompany" name="selectedCompany" style="width: 100%;"
            (change)="onCompanySelect($event)">
            <option value="" disabled>Choose Company</option>
            <option *ngFor="let data of loginData; let i = index" [value]="i">
              {{ data.organization.name }}
            </option>
          </select>
          <div *ngIf="showSelectionError" class="error-text">
            Company is required
          </div>
        </div>
      </form>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="btn cancel" (click)="closeSelectionModal()">Cancel</button>
      <button class="btn success" (click)="onSelectionConfirm()">Confirm</button>
    </div>
  </div>
</div>